export enum ModalResultEnum {
    CANCEL = 'cancel',
    CLOSE = 'close',
    CONFIRM = 'confirm',
}

export enum FormControlStatusEnum {
    VALID = 'VALID',
    INVALID = 'INVALID',
    PENDING = 'PENDING',
    DISABLED = 'DISABLED',
}

export enum SaveEditModeResultEnum {
    CANCEL = 'cancel',
    SAVED_CONTINUE = 'saved_continue',
    SAVED_LAYER = 'saved_layer',
    SAVED_QUIT = 'saved_quit',
}
